module.exports = __webpack_public_path__ + "img/05—Applications—Speed Test 06 > WLAN > Error State 1.e2a7c5c3.jpg";